const departmentKeys = {
    "一般科目": "general",
    "共通専門科目": "specialized",
    "分野展開・系発展": "advanced",
    "機械・知能系": "mechanical",
    "電気・電子系": "electrical",
    "情報・ソフトウェア系": "information",
    "化学・バイオ系": "chemical"
};

const colorVariants = {
    general: {
        cardBorder: "border-slate-500 dark:border-slate-200",
        badge: "bg-slate-200 dark:bg-slate-100 text-slate-800",
        button: "border-slate-400 text-slate-800 dark:text-slate-200 hover:bg-slate-500 hover:text-white",
        focus: "focus-within:outline-none focus-within:bg-slate-500 focus-within:text-white dark:focus-within:bg-slate-400 transition duration-150 ease-in-out"
    },
    specialized: {
        cardBorder: "border-fuchsia-500",
        badge: "bg-fuchsia-100 dark:bg-fuchsia-300 text-fuchsia-800",
        button: "border-fuchsia-400 text-fuchsia-600 dark:text-fuchsia-400 hover:bg-fuchsia-500 hover:text-white",
        focus: "focus-within:outline-none focus-within:bg-fuchsia-500 focus-within:text-white transition duration-150 ease-in-out"
    },
    advanced: {
        cardBorder: "border-orange-500",
        badge: "bg-orange-100 dark:bg-orange-300 text-orange-800",
        button: "border-orange-400 dark:border-orange-500 text-orange-600 dark:text-orange-400 hover:bg-orange-500 hover:text-white",
        focus: "focus-within:outline-none focus-within:bg-orange-500 focus-within:text-white transition duration-150 ease-in-out"
    },
    mechanical: {
        cardBorder: "border-red-500",
        badge: "bg-red-100 dark:bg-red-300 text-red-800",
        button: "border-red-400 dark:border-red-500 text-red-600 dark:text-red-400 hover:bg-red-500 hover:text-white",
        focus: "focus-within:outline-none focus-within:bg-red-500 focus-within:text-white transition duration-150 ease-in-out"
    },
    electrical: {
        cardBorder: "border-yellow-500",
        badge: "bg-yellow-100 dark:bg-yellow-300 text-yellow-800",
        button: "border-yellow-400 text-yellow-600 dark:text-yellow-400 hover:bg-yellow-500 hover:text-white",
        focus: "focus-within:outline-none focus-within:bg-yellow-500 focus-within:text-white transition duration-150 ease-in-out"
    },
    information: {
        cardBorder: "border-blue-500",
        badge: "bg-blue-100 dark:bg-blue-300 text-blue-800",
        button: "border-blue-400 text-blue-600 dark:text-blue-300 hover:bg-blue-500 hover:text-white",
        focus: "focus-within:outline-none focus-within:bg-blue-500 focus-within:text-white transition duration-150 ease-in-out"
    },
    chemical: {
        cardBorder: "border-green-500",
        badge: "bg-green-100 dark:bg-green-300 text-green-800",
        button: "border-green-400 text-green-600 dark:text-green-300 hover:bg-green-500 hover:text-white",
        focus: "focus-within:outline-none focus-within:bg-green-500 focus-within:text-white transition duration-150 ease-in-out"
    }
};

export { departmentKeys, colorVariants };